<!-- 登录页  提货券卡 绑定 -->
<template>
  <div class="card">
    <div class="wrapCard">
      <div class="Hseat"></div>
      <div class="inputForm">
        <div class="telDivCard">
          <i class="iconfont iconiconfontshouji"></i>
          <input class="pswWidth1" type="text" placeholder="请输入卡号" v-model="cardNumber" />
        </div>
        <div class="telDivCard">
          <i class="iconfont iconsuo"></i>
           <input :type="eysTrue ? 'password' : 'text' " placeholder="电子码或密码8-12位不区分大小写" v-model="cardPwd" class="pswWidth1">
            <i :class="['iconfont', eysTrue ? 'icon-eyeopen' : 'icon-eyeclose']" style="float: right" @click="() => eysTrue = !eysTrue"></i>
        </div>
        <div class="clearBoth"></div>

        <div class="telDivCard" v-show="this.isshow" >
          <i class="iconfont iconiconfont5"></i>
           <input class="pswWidth" type="text" placeholder="请输入验证码" v-model="codeNum" />
          <img :src="imgUrl" @click="getCode">
        </div>
        <div class="Hseat"></div>
      </div>
      <div class="loginBtnCard" @click="giftvouchersubmit">确定</div>
      <div class="agremmentCard">
        <p>温馨提示：</p>
        <p>如果只有密码，无需填写第一个输入框内容</p>
      </div>
    </div>
    
  </div>
</template>

<script>
import * as api from "@/api";
import '@/assets/stylecss/iconfont.css'
import JmmToast from "@/components/JmmToast";
import wx from "weixin-js-sdk";
let cardNumberRegular = /^\d{11,13}$/;
export default {
  name: "giftvoucher",
  data() {
    return {
      eysTrue: true,     // 密码框 显示小眼睛
      token: "",
      sign: "",
      cardNumber: "",
      cardPwd: "",
      codeNum: "",
      scanlinks: "",
      businessid: "",
      imgUrl:"",
      imageCode:"",
      isshow:false,
      appid:"",
      testToken:"jjcimpilpgejfeehkdinjlbgabbgchhe",
      testBusinessid:"10005",
      testSign:"dpbijiiiefibmadgopamipinnnpnphof",
      unionid:"",
      openid:"",
      userid:"",
      merchantId: '',
      cityLogo: "",   // 城市logo
      displayType: "",   // 账户显示色调
      stateId: ''
    };
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
    this.scanlinks = this.$route.query.scanlinks;
    this.businessid = this.$route.query.businessid;
      },
  components: {
    JmmToast,
  },
  computed: {},
  mounted: function () {
    //this.wxLogin();
    //this.getCode();
    this.getwebAppId();
    
  },
  methods: {
    // 获取城市appId
    async getwebAppId(){
      try {
        let info = {}
        const res = await api.user.getwebAppId(info)
        if (res.code == "000000") {
          this.appid = res.data.appId;
          this.cityLogo = res.data.logo;
          this.displayType = res.data.displayType;
          if(this.cityLogo == null || this.cityLogo == undefined){
            this.cityLogo = "";
          }
          localStorage.setItem('cityLogo', this.cityLogo);
          localStorage.setItem('displayType', this.displayType);
          this.getwxCode();
        } else {
          this.getwxCode();
        }
      } catch (err) {
        this.getwxCode();
        console.log(err)
      }      
    },
    getwxCode(){ // 非静默授权，第一次有弹框
        
        this.code = ''
        var local = window.location.href; // 获取页面url
        if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
          // 获取授权后的code位置
          var codeBeg = local.indexOf("?code=");
          var codeEnd = local.indexOf("#/?");
          // 截取授权后的code数据
          var codeCut = local.substring(codeBeg, codeEnd);
          local = local.replace(codeCut, "");
        }
        var appid = this.appid; 
        this.code = this.getwxUrlCode().code // 截取code
        if (this.code == null || this.code === '') { // 如果没有code，则去请求
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}#wechat_redirect`
        } else {
          var merchantIdState = this.getwxUrlCode().state // 截取state
          if(null == merchantIdState || undefined == merchantIdState){
            merchantIdState = '';
          }
          if('' == this.merchantId && '' != merchantIdState){
            this.merchantId = merchantIdState;
            localStorage.setItem('cityMerchantId', this.merchantId);
          }
          // 通过code获取信息 
          // JmmToast(this.code);
          //this.getList(this.code);
          console.log(this.code);
          //获取unionid
          this.wxweblogin(this.appid,this.code);  
        }
      },

      getwxUrlCode() { // 截取url中的code方法
      var url = location.search
      this.winUrl = url
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for(var i = 0; i < strs.length; i ++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      return theRequest
      },

      async wxweblogin(appid,wxcode){
         let _this = this;
         try {
         localStorage.setItem("reToken",_this.token == undefined ? _this.testToken : _this.token);
         //JmmToast(appid+"---"+wxcode);
         let info = {
            appId: appid,
            wxcode: wxcode,
          };
         const { code, data, message } = await api.user.weixinweblogin(info);
         //console.log(data);
         //JmmToast(data); 
          if (code == "000000") {
             //存储unoinid sign
             _this.unionid=data.unionid;
             _this.sign=data.sign;
             _this.openid=data.openid;
             _this.userid=data.userid;
             //JmmToast(_this.unionid+"---"+_this.sign);
             this.$nextTick(() => {
               //验证是否显示验证码
               //var isshowcode=localStorage.getItem("isshowcode");
                 // if(qrcodecardnumber!=undefined){
                    //var isshowcodeexptime=localStorage.getItem("isshowcodeexptime");
                    _this.isshow=true;
                    this.getCode();
                  //}
                  //else{
                  //  _this.isshow=false;
                 // }

                 if (_this.scanlinks != undefined) {
                    this.wxLoginScan();
                  }

             });
            
          } else {
            if (res.code == '40163' || res.code == '40029') {
              var local = window.location.href // 获取页面url
              if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
                // 获取授权后的code位置
                var codeBeg = local.indexOf("?code=");
                var codeEnd = local.indexOf("#/?");
                // 截取授权后的code数据
                var codeCut = local.substring(codeBeg, codeEnd);
                local = local.replace(codeCut, "");
              }
              // 重新访问 此路径地址
              window.location.href = local;
            }
          }
         }
         catch (err) {
           JmmToast(err); 
            console.log(err);
          }
      },


    showQRcodeDetails(e){
      let _this = this;
       const codeHtml = document.getElementById("qrcode"+e.cardnumber);
             
             codeHtml.innerHTML = "";
       this.qrcode('qrcode'+e.cardnumber,e.cardnumber,e.cardid);
    },

    async getCode() {
      let _this = this;
      try {
        let testToken = "lmojakdhkadocfaccfjocklccdfkhgoj";
        localStorage.setItem("reToken", _this.token == undefined ? testToken : _this.token);
        let data = await api.user.getCode(this.sign, 'img');
        _this.imgUrl = window.URL.createObjectURL(data);  
      } catch (err) {
        console.log(err);
      }
    },
    //扫码登录
    async wxLoginScan() {
      let _this = this;
      console.log(_this.token);
       
      try {
        if (_this.scanlinks != undefined) {
          let info = {
            businessid:_this.testBusinessid == undefined? _this.testBusinessid : _this.businessid,
            sign: _this.sign,
            scanLinks: _this.scanlinks,
            isbind: 0,
            card: "",
            pwd: "",
          };
           localStorage.setItem("reToken", _this.token==undefined?_this.testToken:_this.token);
        //JmmToast(info.scanLinks);
        const { code, data, message } = await api.user.giftVoucherCardQueryByScan(info);
            if (code == "000000") {
             // let wxInfo = {
              //cardName: data.cardname,
             // controlCommon: data.controlcommon,
             // controlMovie: data.controlmovie,
             // cardType: data.cardtype,
             // cardNumber: data.cardnumber,
            //};
            //JmmToast(data.msg); 
            var gourl="http://kgjc.kangou.cn/index.php/api_card/exchange/init?";
        gourl +="sign="+_this.sign;
        gourl +="&openId="+_this.openid;
        gourl +="&unionId="+_this.unionid;
        gourl +="&userId="+_this.userid;
        gourl +="&openId="+_this.openid;
        gourl +="&cardNum="+data.data.data[0].CardNumber;
        gourl +="&cardPwd="+this.scanlinks;
        gourl +="&cardId="+data.data.data[0].CardId;
        gourl +="&cardName="+data.data.data[0].CardName;
        gourl +="&cardRights="+data.data.data[0].CardRights;
        gourl +="&cardType="+data.data.controlMovie.cardType;
        gourl +="&scanLinks="+this.scanlinks;


        window.location.href=gourl;
             
          }
          else {
          //JmmToast("错误码:" + code + " " + message);
              if (code == "900000") {
                JmmToast("绑定失败，请稍后重试"); 
              }
              else{
                JmmToast(message); 
              }
          
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 点击登录
    async giftvouchersubmit() {
      let _this = this;
      try {
      //  if(_this.cardNumber.length==0||_this.cardNumber.length==13){
    //    }
  //      else{
//JmmToast("当前只支持13位卡登陆，部分卡请在看购福利公众号使用！");
//return;
     //   }
        
        if (_this.cardPwd == "") {
          JmmToast("请输入正确的密码");
          return;
        }
        //if (_this.code == "") {
        //  JmmToast("请输入完整的验证码");
        //  return;
        //}
        
        //执行登陆接口
        let cinfo = {
          sign: _this.sign == undefined ? testSign : _this.sign,
              card: _this.cardNumber,
              pwd: _this.cardPwd,
              isbind: 0,
              scanLinks: "",
              businessid:_this.testBusinessid == undefined? _this.testBusinessid : _this.businessid,
              imageCode:_this.codeNum,
              sign:_this.sign,
              unionId:_this.unionid,
        };
        localStorage.setItem("reToken", _this.token==undefined?_this.testToken:_this.token);
        //JmmToast(cinfo);
        const { code, data, message } = await api.user.giftVoucherCardCardQuery(cinfo);
      
        //JmmToast(data);

        if (code == "000000") {
         // let wxInfo = {
          //cardName: data.cardname,
          //controlCommon: data.controlcommon,
          //controlMovie: data.controlmovie,
          //cardType: data.cardtype,
          //cardNumber: data.cardnumber,
          //};
        JmmToast(data.msg); 
        var gourl="http://kgjc.kangou.cn/index.php/api_card/exchange/init?";
        gourl +="sign="+_this.sign;
        gourl +="&openId="+_this.openid;
        gourl +="&unionId="+_this.unionid;
        gourl +="&userId="+_this.userid;
        gourl +="&openId="+_this.openid;
        gourl +="&cardNum="+_this.cardNumber;
        gourl +="&cardPwd="+_this.cardPwd;
        gourl +="&cardId="+data.data.data[0].CardId;
        gourl +="&cardName="+data.data.data[0].CardName;
        gourl +="&cardRights="+data.data.data[0].CardRights;
        gourl +="&cardType="+data.data.controlMovie.cardType;
        gourl +="&scanLinks="+this.scanlinks;


        window.location.href=gourl;
            
          
        } else {
          //JmmToast("错误码:" + code + " " + message);
          if (code == "900000") {
                JmmToast("绑定失败，请稍后重试"); 
              }
              else{
                JmmToast(message); 
              }
        }
      } catch (err) {
        console.log(err);
      }
    },
    
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl';
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';

.wrapCard {
  width: 100%;
  height: 100%;
}

.headWrapCard {
  height: 88px;
  line-height: 88px;
  font-size: 36px;
  color: #262626;
  display: flex;
  width: calc(100% - 48px);
  margin: 0 auto;

  span {
    flex: 1;
  }

  span:nth-child(1) img {
    width: 22px;
    height: 38px;
    vertical-align: middle;
  }

  span:nth-child(2) {
    text-align: center;
  }
}

.Hseat {
  height: 129px;
}

.wrapCard .telDivCard {
  width: calc(100% - 150px);
  margin: 15px auto;
  height: 110px;
  border-bottom: 1px solid #ddd;

  i {
    font-style: normal;
    margin-top: 30px;
    float: left;
  }

  input {
    height: 80px;
    font-size: 45px;
    margin-left: 20px;
    border: none;
  }

  button {
    border: 2px solid $codeColor;
    width: 180px;
    height: 66px;
    font-size: 28px;
    background: $codeColor;
    color: black;
    float: right;
    cursor: pointer;
  }

  .pswWidth {
    width: 320px !important;
    font-size 32px
    display: inline;
  }

  .pswWidth1 {
    width: 470px !important;
    display: inline;
    font-size 32px
  }
}

.wrapCard .telDivCard img {
  width: 30% !important;
  height: 45px !important;
  display: inline-block;
  vertical-align: middle;
}

.loginBtnCard {
  width: calc(100% - 150px);
  height: 90px;
  line-height: 90px;
  margin: 0 auto;
  background: $background;
  border-radius: 45px;
  font-size: 34px;
  text-align: center;
  color: $color;
  cursor: pointer;
}

.agremmentCard {
  width: calc(100% - 224px);
  margin: 32px auto;
  font-size: 24px;

  span {
    cursor: pointer;
  }
}

.clearBoth {
  clear: both;
}

.leftRouter {
  float: $floLeft;
}

.rightRouter {
  float: $florRight;
}



.card {
  background: #fff;
  height: 100%;
}

input::-webkit-input-placeholder{ /*WebKit browsers*/

font-size :28px;
line-height :70px;

}

input::-moz-input-placeholder{ /*Mozilla Firefox*/

font-size :28px;
line-height :70px;

}

input::-ms-input-placeholder{ /*Internet Explorer*/ 

font-size :28px;
line-height :70px;

}
</style>



// WEBPACK FOOTER //
// src/view/giftvoucher/index.vue